import { Color } from '@tiptap/extension-color';
import FontFamily from '@tiptap/extension-font-family';
import TableRow from '@tiptap/extension-table-row';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';

import { CustomLink, CustomListItem, CustomParagraph, FontSize, LineHeight } from '../common/extensions';
import {
  CellSelection,
  ColumnResizing,
  CustomTable,
  CustomTableCell,
  CustomTableHeader,
  Document,
  EmptyTextStyle,
} from './extensions';
import { Checkbox } from './extensions/Checkbox';
import { ValidateMovement } from './extensions/validateMovement';

export const CELL_MIN_WIDTH = 25;

export const extensions = [
  Document,
  CustomLink,
  StarterKit.configure({
    document: false,
    heading: false,
    listItem: false,
    codeBlock: false,
    paragraph: false,
    strike: false,
    code: false,
    blockquote: false,
  }),
  CustomParagraph,
  CustomTable,
  CustomTableHeader,
  CustomTableCell,
  TableRow,
  ColumnResizing.configure({
    lastColumnResizable: false,
    cellMinWidth: CELL_MIN_WIDTH,
    defaultCellMinWidth: CELL_MIN_WIDTH,
  }),
  CellSelection,
  CustomListItem,
  TextStyle,
  FontFamily,
  FontSize,
  Underline,
  Color,
  Checkbox,
  ...[LineHeight, TextAlign].map((extension) =>
    extension.configure({
      types: ['heading', 'paragraph', 'title'],
    }),
  ),
  ValidateMovement,
  EmptyTextStyle,
];

export const getReadonlyExtensions = (
  isExport: boolean,
  forceAllowInteractive: boolean,
  onCheckboxChange?: (checkboxId: string, isChecked: boolean) => void,
) => [
  Document,
  // Preview link allows to click and update checkbox state directly in DB
  Checkbox.configure(
    forceAllowInteractive
      ? { HTMLAttributes: { style: 'pointer-events: auto' }, hasCheckedAnimation: true, onChange: onCheckboxChange }
      : {},
  ),
  CustomLink.configure({ shouldKeepSameHyperlink: isExport }),
  StarterKit.configure({
    document: false,
    heading: false,
    listItem: false,
    codeBlock: false,
    paragraph: false,
    strike: false,
    code: false,
    blockquote: false,
  }),
  CustomParagraph,
  CustomTable,
  CustomTableHeader,
  CustomTableCell,
  TableRow,
  ColumnResizing.configure({ lastColumnResizable: true, cellMinWidth: CELL_MIN_WIDTH }),
  CellSelection,
  CustomListItem,
  TextStyle,
  FontFamily,
  FontSize,
  Underline,
  Color,
  ...[LineHeight, TextAlign].map((extension) =>
    extension.configure({
      types: ['heading', 'paragraph', 'title'],
    }),
  ),
  ValidateMovement,
  EmptyTextStyle,
];

export const DEFAULT_CARET_COLOR = '#000000';
